import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
    const { pathname } = useLocation()

    useEffect(() => {
        // 立即跳转到顶部，不使用 smooth 以免产生视觉延迟
        window.scrollTo(0, 0)
    }, [pathname])

    return null
}
